import { useEffect, useState } from "react";
import { useLocation, useRouteLoaderData } from "react-router";
import * as gtag from "~/modules/analytics/gtag";
import type { loader } from "~/root";

export function GoogleScripts() {
  const data = useRouteLoaderData<typeof loader>("root");
  const location = useLocation();
  const gaTrackingIds = data?.gaTrackingIds ?? [];
  const [isInjected, setIsInjected] = useState(false);

  useEffect(() => {
    if (isInjected && gaTrackingIds?.length) {
      gaTrackingIds.forEach((gaTrackingId) => {
        gtag.pageview(location.pathname, gaTrackingId);
      });
    }
  }, [location, gaTrackingIds, isInjected]);

  useEffect(() => {
    if (isInjected) return;
    if (data?.googleTagManager && gaTrackingIds.length > 0) {
      setIsInjected(true);

      const scriptHtml = `(function(w, d, s, l, i) {
                  w[l] = w[l] || [];
                  w[l].push({
                      'gtm.start': new Date().getTime(),
                      event: 'gtm.js'
                  });
                  var f = d.getElementsByTagName(s)[0],
                      j = d.createElement(s),
                      dl = l != 'dataLayer' ? '&l=' + l : '';
                  j.async = true;
                  j.src =
                      'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                  f.parentNode.insertBefore(j, f);
              })(window, document, 'script', 'dataLayer', '${data.googleTagManager.id}');`;
      const script = window.document.createElement("script");
      script.innerHTML = scriptHtml;
      window.document.head.appendChild(script);
    }
  }, []);

  return (
    <>
      {!!data?.googleTagManager?.id && data?.googleTagManager?.clientId && (
        <noscript>
          <iframe
            title="Google Tag Manager"
            src={`https://www.googletagmanager.com/ns.html?id=${data.googleTagManager.id}`}
            height="0"
            width="0"
            className="hidden invisible"
          />
        </noscript>
      )}

      {gaTrackingIds?.map((gaTrackingId) => (
        <script
          async
          key={gaTrackingId}
          src={`https://www.googletagmanager.com/gtag/js?id=${gaTrackingId}`}
        />
      ))}

      {gaTrackingIds.length > 0 && (
        <script
          async
          id="gtag-init"
          // biome-ignore lint/security/noDangerouslySetInnerHtml: required to insert the tracking id
          dangerouslySetInnerHTML={{
            __html: `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());

                ${gaTrackingIds
                  .map(
                    (gaTrackingId) =>
                      `gtag('config', '${gaTrackingId}', { page_path: window.location.pathname, });`,
                  )
                  .join("\n")}
            `,
          }}
        />
      )}
    </>
  );
}
